import eventHub from '@/scripts/eventHub';
import { sendGAEvent } from '@/scripts/utils';

export default {
  startGame({ commit, state }) {
    const index = Math.floor(Math.random() * state.questions.length);
    const groupSelected = state.questions[index];

    commit('SET_GROUP_INDEX', index);
    commit('SET_RANDOM_QUESTIONS_ID', Object.keys(groupSelected));

    // TODO: decide mq mobile
    if (window.innerWidth >= 768 && !state.currentGame.gameEnded) eventHub.$emit('showIllustration', 2000);
    if (state.currentGame.gameEnded) eventHub.$emit('restartIllustration');

    commit('START_GAME');
  },

  checkAnswer({ commit, state }, answer) {
    const currentKey = state.currentGame.questionsIdList[state.currentGame.questionsIndex];
    const currentQuestion = state.questions[state.currentGame.groupIndex][currentKey];

    if (currentQuestion.correctValue === answer) {
      commit('CORRECT_ANSWER');
      // TODO: decide mq mobile
      if (window.innerWidth >= 768) eventHub.$emit('illustrationUpdateResult');
    } else commit('WRONG_ANSWER');
  },

  next({ commit, state }) {
    const { currentGame } = state;
    if (currentGame.questionsIndex < currentGame.questionsIdList.length - 1) commit('INCREASE_QUESTIONS');
    else {
      commit('END_GAME');
      if (state.currentGame.partialScore === 4) {
        sendGAEvent('Completed Versions', `V${state.currentGame.groupIndex + 1}`);
      }
    }
  },

  share() {
    sendGAEvent('Share');
  },
};
